module.exports = __webpack_public_path__ + "static/img/王琦.d0c9e5fe.png";